import React from 'react'
import { Icon } from '@fluentui/react/lib/Icon'
import { /* ChevronLeft,  */ChevronRight, MoreVertical } from 'react-feather';
import colors from '../../../utils/colors';
import { ActionPopup } from '../../../components';

const Edit = () => <Icon iconName="Edit" className="ms-Edit text-xl" />;
const Delete = () => <Icon iconName="Delete" className="ms-Delete text-xl" />;

const data = [
  {
    english: 'veniam consequat sunt nostrud amet',
    indonesia: 'Sunt nostrud amet',
    report: 'Laporan.pdf',
    status: 'completed',
  },
  {
    english: 'veniam consequat sunt nostrud amet',
    indonesia: 'Sunt nostrud amet',
    report: 'Laporan.pdf',
    status: 'completed',
  },
  {
    english: 'veniam consequat sunt nostrud amet',
    indonesia: 'Sunt nostrud amet',
    report: 'Laporan.pdf',
    status: 'incomplete',
  },
  {
    english: 'veniam consequat sunt nostrud amet',
    indonesia: 'Sunt nostrud amet',
    report: 'Laporan.pdf',
    status: 'completed',
  },
]

const LocationRow = ({data, onEdit}) => {
  const [open, setOpen] = React.useState(false)
  const [popedUp, setPopedUp] = React.useState(false)

  const actionButtonClasses = "cursor-pointer text-sm text-white h-full flex flex-col items-center justify-center py-5"
  const actionButtonStyles = {
    minWidth: '67px'
  }

  return (
    <tr className="text-sm text-gray-444 location-row">
      <td className="align-top">
        <div className="mb-5">
          <div className="text-gray-999 text-xs">English</div>
          {data.english}
        </div>
        <div className="mb-5">
          <div className="text-gray-999 text-xs">Indonesia</div>
          {data.indonesia}
        </div>
        <div className="flex lg:block -mx-2 lg:mx-0">
          <div className="w-1/2 lg:w-full px-2 lg:px-0">
            <div className="text-gray-999 text-xs">Report</div>
            {data.report}
          </div>
          <div className="lg:hidden w-1/2 px-2">
            <div className="text-gray-999 text-xs">Status</div>
            <div className="text-xs">
              <span className="capitalize" style={{color: data.status === 'completed' ? colors.green : '#444'}}>{data.status}</span>
            </div>
          </div>
        </div>
      </td>
      <td className="hidden lg:table-cell align-top">
        <div className="text-xs">
          <span className="capitalize" style={{color: data.status === 'completed' ? colors.green : '#444'}}>{data.status}</span>
        </div>
      </td>
      <td className="relative align-top">
        <div className="hidden lg:flex items-center">
          <p className="cursor-pointer underline text-xs text-gray-999 mr-2" onClick={onEdit}>Edit</p>
          <p className="cursor-pointer underline text-xs text-gray-999">Delete</p>
        </div>
        <MoreVertical className="ml-auto lg:hidden text-gray-999" onClick={() => setPopedUp(true)} />
        {
          popedUp &&
          <ActionPopup handleClose={() => setPopedUp(false)} onEdit={onEdit}/>
        }

        {/* Backup */}
        {/* <ChevronLeft className="lg:hidden" onClick={() => setOpen(true)}/> */}
        {
          open &&
          <div className="flex items-center absolute top-0 right-0 h-full">
            <div
              className="h-full flex items-center justify-end pr-4"
              style={{width: '183px', background: 'linear-gradient(270deg, #FFFFFF 27.22%, rgba(255, 255, 255, 0) 95.83%)'}}
              onClick={() => setOpen(false)}
            >
              <ChevronRight />
            </div>
            <div
              className={`bg-primary ${actionButtonClasses}`}
              style={{...actionButtonStyles}}
              onClick={onEdit}
            >
              <Edit/>
              <p className="underline mt-2">Edit</p>
            </div>
            <div
              className={`${actionButtonClasses}`}
              style={{background: '#999', ...actionButtonStyles}}
            >
              <Delete/>
              <p className="underline mt-2">Delete</p>
            </div>
          </div>
        }
      </td>
    </tr>
  )
}

const MilestoneTable = ({onEdit}) => {
  return (
    <table className="table table--striped mb-8 lg:mb-0">
      <tbody>
        {
          data.map((d, index) => (
            <LocationRow key={index} data={d} onEdit={onEdit} />
          ))
        }
      </tbody>
    </table>
  )
}

export { MilestoneTable }